import { $, $$, insertHTML } from 'utils/dom';
import loadGoogleMapsApi from 'modules/load-google-maps-api';
import { mapStyles } from './config.js';

// Settings // --------------------------------------------------------
const map = $('.audioguide-map');
const googleMapTestKey = 'AIzaSyB5iZG5IxplqZjxER4i9KFahEDK_oEIaag';
const API_SETTINGS = {
  key: window.googleMapAPIKey || googleMapTestKey,
  timeout: 10000,
  v: 3,
};

export default class GoogleMap {
  constructor(api, map) {
    this.api = api;
    this.container = map;
    this.target = $('#map', this.container);
    this.markers = this.container.dataset.markers;
    this.route = this.container.dataset.route;
    this.googleMap = null;
    this.openModalButtons = $$('.audioguide-map__modalopen', this.container);
    this.modals = $$('.audioguide-map__modal', this.container);
    this.closeModalButtons = $$('.audioguide-map__modalclose', this.container);
    this.htmlMarker = [];
    this.routeCoordinates = [];
    this.errorModal = $('.audioguide-map__error-modal', this.container);
    this.errorModalInner = $(
      '.audioguide-map__error-modal-inner',
      this.container
    );
    this.errorModalClose = $(
      '.audioguide-map__error-modal-close',
      this.container
    );
  }

  create = () => {
    this.googleMap = new this.api.Map(this.target, {
      disableDefaultUI: true,
      scrollwheel: false,
      styles: mapStyles,
      minZoom: 13,
      maxZoom: 19,
      clickableIcons: false,
    });

    this.initZoomControl(); // use our own zoom controls
    this.createMarkers(); // create markers
    this.createPolyline(); // draw lines
    this.zoomMapToMarkers(); // adjust zoom level to cover all markers
    this.trackUserLocation(); // track user location on map
    this.bindEvents();
  };

  bindEvents = () => {
    this.closeModalButtons.length && this.bindModalCloseButtons();
    window.addEventListener('resize', this.zoomMapToMarkers);
  };

  bindModalCloseButtons = () => {
    this.closeModalButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        // close active marker
        this.htmlMarker.forEach(marker => {
          if (marker.button.classList.contains('is-active')) {
            marker.button.classList.remove('is-active');
          }
        });

        // close active modal
        this.modals.forEach(modal => {
          if (modal.classList.contains('is-active')) {
            modal.classList.remove('is-active');
          }
        });
      });
    });
  };

  initZoomControl = () => {
    this.googleMap.controls[this.api.ControlPosition.LEFT_BOTTOM].push(
      $('.zoom-control', this.container)
    );

    $('.zoom-control-in', this.container).onclick = () => {
      this.googleMap.setZoom(this.googleMap.getZoom() + 1);
    };

    $('.zoom-control-out', this.container).onclick = () => {
      this.googleMap.setZoom(this.googleMap.getZoom() - 1);
    };
  };

  createMarkers = () => {
    const thisClass = this;
    const that = this.api;
    const markersArray = JSON.parse(this.markers);

    function HTMLMarker(lat, lng, id, index) {
      this.lat = lat;
      this.lng = lng;
      this.id = id;
      this.index = index;
      this.pos = new that.LatLng(lat, lng);
    }

    HTMLMarker.prototype = new this.api.OverlayView();
    HTMLMarker.prototype.onRemove = function () {};

    HTMLMarker.prototype.onAdd = function () {
      const button = document.createElement('BUTTON');
      button.style.position = 'absolute';
      button.className = 'audioguide-map__modalopen';
      button.setAttribute('data-id', this.id);
      button.innerHTML = this.index + 1;
      const panes = this.getPanes();
      panes.overlayImage.appendChild(button);
      this.button = button;
      thisClass.markerEvent(button, this.index);
    };

    HTMLMarker.prototype.draw = function () {
      const overlayProjection = this.getProjection();
      const position = overlayProjection.fromLatLngToDivPixel(this.pos);
      this.button.style.left = position.x + 'px';
      this.button.style.top = position.y - 30 + 'px';
    };

    markersArray.forEach((marker, index) => {
      const { lat, lng, id } = marker;
      const htmlMarker = new HTMLMarker(+lat, +lng, id, index);
      htmlMarker.setMap(this.googleMap);
      this.htmlMarker.push(htmlMarker);
    });
  };

  markerEvent = (button, key) => {
    button.addEventListener('click', () => {
      button.classList.toggle('is-active');

      // close all other markers
      this.htmlMarker.forEach((marker, index) => {
        if (key !== index) marker.button.classList.remove('is-active');
      });

      // toggle the match modal to active, every modal that doesnt match getting inactive
      this.modals.forEach((modal, index) => {
        if (modal.getAttribute('data-id') === button.getAttribute('data-id')) {
          modal.classList.toggle('is-active');
        } else {
          modal.classList.remove('is-active');
        }
      });

      // pan map to marker
      const panPoint = new this.api.LatLng(
        this.htmlMarker[key].lat,
        this.htmlMarker[key].lng
      );
      this.googleMap.panTo(panPoint);
    });
  };

  createPolyline = () => {
    const routeArray = JSON.parse(this.route);

    routeArray.forEach(route => {
      this.routeCoordinates.push(route);
    });

    const routePath = new this.api.Polyline({
      path: this.routeCoordinates,
      geodesic: true,
      strokeColor: '#00000',
      strokeOpacity: 1.0,
      strokeWeight: 3,
    });
    routePath.setMap(this.googleMap);
  };

  zoomMapToMarkers = () => {
    const bounds = new this.api.LatLngBounds();

    this.htmlMarker.forEach(marker => {
      bounds.extend(marker);
    });

    this.googleMap.fitBounds(bounds);
  };

  trackUserLocation = () => {
    const initialPosition = { lat: 52.50377, lng: 13.39823 };

    const userMarker = new this.api.Marker({
      map: this.googleMap,
      position: initialPosition,
      icon: {
        anchor: new this.api.Point(12, 12),
        url:
          // eslint-disable-next-line no-multi-str
          'data:image/svg+xml;utf-8, \
          <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"> \
            <circle cx="13" cy="13" fill="royalblue" r="10" stroke="white" stroke-width="3"/> \
          </svg>',
      },
    });

    const getPositionErrorMessage = code => {
      // eslint-disable-next-line default-case
      switch (code) {
        case 1:
          return `
          Zugriff auf die Positionsdaten wurde verweigert. Stellen Sie sicher, dass ihr Browser auf ihre Standortdaten zugreifen kann. <br> <br>
          <a href="https://support.apple.com/de-de/HT207092" target="_blank">Anleitung Apple iOS</a> <br/>
          <a href="https://support.google.com/accounts/answer/6179507?hl=de&ref_topic=7189122" target="_blank">Anleitung Android</a>
          `;
        case 2:
          return `Positionsdaten nicht verfügbar.`;
        case 3:
          return `Timeout bei der Abfrage der Positiondaten.`;
      }
    };

    const showErrorModal = html => {
      this.errorModal.classList.add('is-active');
      insertHTML(this.errorModalInner, 'beforeend', html);
      this.errorModalClose.addEventListener('click', () => {
        this.errorModal.classList.remove('is-active');
      });
    };

    if ('geolocation' in navigator) {
      navigator.geolocation.watchPosition(
        position => {
          // Set marker's position.
          userMarker.setPosition({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        error => showErrorModal(getPositionErrorMessage(error.code))
      );
    } else {
      showErrorModal('Ihr Browser unterstützt keine Positionsdaten.');
    }
  };
}

// InitMap // -----------------------------------------------------------
if (map) {
  const initMap = (api, map) => {
    const googleMap = new GoogleMap(api, map);
    googleMap.create(); // create map
  };

  const googleMapsAPI = loadGoogleMapsApi(API_SETTINGS);
  googleMapsAPI.then(api => {
    initMap(api, map);
  });
}
